import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import {
  PricingSchemeLinkUpdateQueueContainerModel
} from '../../../../../../models/aggregates/erp/pricing-scheme';

@Injectable({
  providedIn: 'root'
})
export class PricingSchemeLinkUpdateQueueService extends BaseApiTemplateService<PricingSchemeLinkUpdateQueueContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'pricing-scheme-link-update-queue';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'pricing-scheme-link-update-queue';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'pricing-scheme-link-update-queue';
    this.httpClient = http;
  }

}


